exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".margin-right-10 {\n  margin-right: 10px; }\n\n.align-center-vertically {\n  display: flex;\n  display: -ms-flexbox;\n  align-items: center; }\n\n.icon-padding-05 {\n  padding: 5px; }\n\n.branch-margin-top {\n  margin-top: -9px; }\n\n.span-border-right {\n  border-right: solid 2px;\n  padding-right: 5px; }\n\n.route-history-badge {\n  border-radius: 4px !important;\n  background-color: #5cb85c !important;\n  font-size: 13px !important;\n  padding-left: 0px; }\n\n.route-display-section .list-group-item {\n  padding: 8px 12px !important; }\n\n.route-history-alert-section .alert {\n  padding: 10px !important; }\n\n.route-history-pagination-section .pagination {\n  display: block !important; }\n\n.span-border-left {\n  border-left: solid 2px;\n  padding-left: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/routes/all/routes.all.scss
// module id = 1082
// module chunks = 1